import { ProgressButton } from '@enroller/admissions-components';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
// import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
// import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { Button, Stack, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useHeaderContext } from '../contexts/HeaderContext';

import { ValidationType } from '../utils/ValidationType';
import { TranslateButton } from './TranslateButton';

export const Header = () => {
  const theme = useTheme();
  const { headerTitle, triggerSubmit, isFormLoading, formProgress, isFormSubmitted } = useHeaderContext();
  const progress = useMemo(() => parseInt(formProgress.toFixed(0)), [formProgress]);

  if (!headerTitle?.title) return <></>;

  if (!headerTitle.subtitle) {
    return (
      <Stack direction="row" justifyContent="space-between" alignItems="center" height="100%" px={4}>
        <Typography color="textPrimary" fontWeight={400} variant="h1" fontSize={theme.spacing(3)}>
          {headerTitle.title}
        </Typography>
        <Stack direction="row" spacing={2}>
          <TranslateButton />
        </Stack>
      </Stack>
    );
  }

  const isOnCourseReservationPage = headerTitle.subtitle === 'Student Details';

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" height="100%" px={4}>
      <Stack direction="column">
        <Typography color="textPrimary">{headerTitle.title}</Typography>
        <Typography variant="body2" color="textPrimary">
          {headerTitle.subtitle}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center">
        {/* TODO: re-enable section navigation buttons */}
        {/*<IconButton disabled={!previousPage} component={Link} href={previousPageUrl} color="secondary" sx={theme.mixins.roundedIconButton}>*/}
        {/*  <ArrowBackOutlinedIcon />*/}
        {/*</IconButton>*/}

        {/*<IconButton disabled={!nextPage} component={Link} href={nextPageUrl} color="secondary" sx={theme.mixins.roundedIconButton}>*/}
        {/*  <ArrowForwardOutlinedIcon />*/}
        {/*</IconButton>*/}
        {isOnCourseReservationPage && !isFormSubmitted && (
          <>
            <Button variant="outlined" color="primary" loading={isFormLoading} onClick={() => triggerSubmit(ValidationType.Draft)}>
              <Trans>Save draft</Trans>
            </Button>
            <ProgressButton
              submitText={t`Submit Application`}
              progressText={t`Progress ${progress}%`}
              loading={isFormLoading}
              onClick={() => triggerSubmit(ValidationType.Full)}
              progress={progress}
            />
          </>
        )}
        <TranslateButton />
      </Stack>
    </Stack>
  );
};
